<template>
  <div
    data-aos="fade-up"
    data-aos-duration="800"
    class="steps-card"
    :class="classObject"
  >
    <div class="steps-number">0{{ index + 1 }}.</div>
    <div class="card-body">
      <div class="icon-wrap">
        <img :src="require(`@/assets/icons/${item.image}`)" alt="steps" />
      </div>
      <div class="text-content">
        <div class="card-title">
          {{ item.title }}
        </div>
        <div class="card-description">
          {{ item.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    item: {
      type: Object
    },
    index: {
      type: Number
    },
    extraClass: {
      type: [String, Array]
    }
  },
  computed: {
    classObject() {
      return this.extraClass ? this.extraClass : "";
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/_variable.scss";
@import "@/scss/_mixins.scss";
.steps-card {
  position: relative;
  padding-left: 45px;
  margin-left: 50px;
  &::before {
    content: "";
    position: absolute;
    left: 7px;
    top: 20px;
    height: calc(100% - 40px);
    width: 2px;
    border-radius: 4px;
    background: rgba(33, 33, 100, 0.5);
  }
  .steps-number {
    position: absolute;
    top: 0;
    left: 0;
    font-family: $content-font;
    font-size: 14px;
    font-weight: 500;
    color: rgba(33, 33, 100, 0.3);
  }
  .card-body {
    display: flex;
    .icon-wrap {
      width: 75px;
      height: 75px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #ffffff;
      border-radius: 19px;
      @include boxShadow(3px, 3px, 20px, 0px, rgba(33, 33, 100, 0.1));
      img {
        width: 30px;
      }
    }
    .text-content {
      padding-left: 35px;
      width: calc(100% - 75px);
      .card-title {
        font-family: $content-font;
        font-size: 18px;
        color: #212164;
        font-weight: bold;
        padding-bottom: 8px;
      }
      .card-description {
        font-family: $content-font;
        font-size: 16px;
        line-height: 24px;
        color: #707070;
        opacity: 0.8;
        font-weight: normal;
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .steps-card {
    .card-body {
      .icon-wrap {
        width: 60px;
        height: 60px;
        img {
          width: 25px;
        }
      }
      .text-content {
        .card-title {
          font-size: 16px;
        }
        .card-description {
          font-size: 14px;
          line-height: 22px;
        }
      }
    }
  }
}

@media only screen and (max-width: 475px) {
  .steps-card {
    padding-left: 0;
    &::before {
      display: none;
    }
    .steps-number {
      display: none;
    }
    .card-body {
      flex-direction: column;
      .icon-wrap {
        width: 60px;
        height: 60px;
        margin: 0 auto;
        img {
          width: 25px;
        }
      }
      .text-content {
        width: 100%;
        padding: 20px;
        .card-title {
          text-align: center;
        }
        .card-description {
          text-align: center;
        }
      }
    }
  }
}
</style>
